module.exports = __webpack_public_path__ + "static/media/03_07_05.a49fdfc0.png";